import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';
import { api } from './api';

/**
 * When the session has gone, say so.
 *
 * Sessions end while the app is open: the counter machine sleeps, the power
 * goes, somebody signs out on another tab. Without this, the next request comes
 * back refused and every list shows "did not load" — which reads as a broken
 * server rather than "sign in again".
 *
 * Marking the session stale makes the session query run, which fails, which
 * puts the sign-in screen up. One path, whichever request noticed first.
 */
export const authExpiryMiddleware: Middleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as { status?: number | string } | undefined;
    const status = payload?.status;

    // The session query failing is the signal itself; invalidating on it would
    // refetch forever.
    const meta = action.meta as { arg?: { endpointName?: string } } | undefined;
    const isSessionRequest = meta?.arg?.endpointName === 'session';

    if ((status === 401 || status === 403) && !isSessionRequest) {
      store.dispatch(api.util.invalidateTags(['Session']));
    }
  }

  return next(action);
};
